import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Toaster } from 'react-hot-toast';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import DefaultLayout from './components/DefaultLayout';

function App() {
  return (
    <>
     <LocalizationProvider dateAdapter={AdapterDayjs}>
    <Toaster position="top-right" toastOptions={{ duration: 4000 }} />
    <Router>
      <DefaultLayout/>
      {/* <Routes>
        <Route path="/" element={<AdminDashboard />} />
        <Route path="/users" element={<UserListPage />} />
        <Route path="/payrolls" element={<PayrollManagement />} />
        <Route path="/leaves" element={<LeaveManagement />} />
      </Routes> */}
    </Router></LocalizationProvider>
    </>
  );
}

export default App;
